export default __webpack_public_path__ + "static/media/dennis-og-thomas-laerlingeansvarlig-fastbraendte-subs.d15aaee4.mp4";